module.exports = __webpack_public_path__ + "static/media/profile.1871862d.png";